angular.module('impactx.supplierbaskettemplate').controller('SupplierBasketTemplateListCtrl', [
    '$scope',
    'TranslationService',
    'dataGen',
    '$mdDialog',
    '$context',
    '$redirect',
    'selectedListItems',
    SupplierBasketTemplateListCtrl]);

function SupplierBasketTemplateListCtrl($scope, TranslationService, dataGen, $mdDialog, $context, $redirect, selectedListItems) {
    var ctrl = this;
    this.newSupplierBasketTemplate = function(event) {
        $mdDialog.show({
            controller: "SupplierBasketTemplateClientSelectionCtrl",
            controllerAs: "supplierBasketTemplateClientSelectionCtrl",
            templateUrl: "modules/supplierbaskettemplate/templates/supplierbaskettemplateclientselection.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                confirmLabel: TranslationService.get('accept'),
                abortLabel: TranslationService.get('abort')
            }
        });
    };

    ctrl.getPrintToken = function(){
        return selectedListItems.getFirstSelectedItem().printTokens.sbt;
    };

    ctrl.addToBasketCondition = function(){
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem() && selectedListItems.getFirstSelectedItem().canAddToBasket.value;
    };

    ctrl.addToCurrentBasket = function() {
        dataGen.post($scope, {selected: [{id: selectedListItems.getFirstSelectedId()}]}, "/basket/addtocurrentbasket").then(function() {
            $context.refreshBasket({}, dataGen, $context);
            $redirect.redirectTo(null, "/basket");
        }, function () {
            $context.refreshBasket({}, dataGen, $context);
        });
    };

    ctrl.getDetailsLink = function(){
        var selectedItem = selectedListItems.getFirstSelectedItem();
        if (selectedItem)
        {
            return 'supplierbasket/' + selectedListItems.getFirstSelectedId() + '/0/0' +
                (selectedItem.canActivate && selectedItem.canActivate.value ? '/1' : '');
        }
    };
    
    var buttonDefinition = [
        {label: "detailsLabel", type: 'link', linkFunction: ctrl.getDetailsLink, condition: selectedListItems.isSingleSelection, process: 'SupplierBasketTemplateEdit'},
        {
            label: "printLabel",
            condition: selectedListItems.isSingleSelection,
            type: 'print',
            params: {
                printTokenFunction: ctrl.getPrintToken
            }
        },
        {label: "addToBasket", action: ctrl.addToCurrentBasket, condition: ctrl.addToBasketCondition}
    ];

    
    this.meta = {
        rowTemplate: 'modules/supplierbaskettemplate/templates/supplierbaskettemplatelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/supplierbaskettemplate/list',
        id: "supplierbaskettemplatelist",
        mainActionFunction: {id: "new", action: this.newSupplierBasketTemplate, icon: "mdi-plus"},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function() {
        return this.meta;
    };
}
